import * as z from 'zod';

/**
 * Frontend password rules mirror the auth service (`5000 ErrValidation`):
 * 8–128 characters with at least one letter and one digit. The backend stays
 * authoritative — anything it rejects beyond this lands on the matching field
 * via the `details` array, or in the inline alert via the code's translation.
 */
const newPasswordSchema = (t: (key: string) => string) =>
  z
    .string()
    .min(8, t('auth.passwordMinLength'))
    .max(128, t('auth.passwordMaxLength'))
    .regex(/^(?=.*\p{L})(?=.*\d)/u, t('auth.passwordLettersAndDigits'));

/**
 * Local form schema. `confirm_password` is frontend-only (the matching check
 * lives here, via react-hook-form + zod) — the request sends just
 * `{old_password, new_password}`.
 */
export function changePasswordFormSchema(t: (key: string) => string) {
  return z
    .object({
      old_password: z.string().min(1, t('auth.passwordRequired')),
      new_password: newPasswordSchema(t),
      confirm_password: z.string().min(1, t('auth.passwordRequired')),
    })
    .refine((values) => values.new_password === values.confirm_password, {
      message: t('auth.passwordsDoNotMatch'),
      path: ['confirm_password'],
    });
}
export type ChangePasswordFormValues = z.infer<
  ReturnType<typeof changePasswordFormSchema>
>;
